

document.addEventListener('DOMContentLoaded', function () {
    const accordions = document.querySelectorAll('.accordion-container');

    accordions.forEach(function (accordion) {
        let firstQuestion = accordion.querySelector('.accordion');
        if (firstQuestion) {
            firstQuestion.classList.add('active');
        }
        const panel = firstQuestion.nextElementSibling;
        if (panel.style.display === "block") {
            panel.style.display = "none";
        } else {
            panel.style.display = "block";
        }
    });
});